import React from "react";
import { Box, Card } from "@material-ui/core";
import { get, orderBy, uniqBy, isEmpty } from "lodash";
import UserSummaryBanner from "Components/UserSummaryBanner";
import { selectedKpiLabel } from "../../../../utils/successStory";
import useTeamSuccessStoryApis from "../../../../hooks/report/useTeamSuccessStoryApis";
import { DISCUSSIONPOINT_MANAGER } from "../../../../constants/literalConstant";
import useStyles from "./../styles";
import SuperviseeKpiList from "Modules/SuccessStory/PreviewSuccessStory/KpiList/SuperviseeKpiList";
import TargetDetails from "Modules/SuccessStory/PreviewSuccessStory/TargetDetails";
import WeightedLinkedTargets from "Modules/SuccessStory/PreviewSuccessStory/WeightedLinkedTargets";
// import NotesForSS from "Modules/SuccessStory/PreviewSuccessStory/Notes";
// import Takeaways from "Modules/SuccessStory/PreviewSuccessStory/Takeaways";
import { selectedSuccessStoryState } from "Recoil/SuccessStory/atom";
import { useRecoilValue } from "recoil";
// import CreatorNotesForSS from "Modules/SuccessStory/PreviewSuccessStory/Notes/CreatorNotesForSS";
// import CreatorTakeawayForSS from "Modules/SuccessStory/PreviewSuccessStory/Takeaways/CreatorTakeawayForSS";
import SuccessstoryNotes from "Modules/SuccessStory/PreviewSuccessStory/NoteCopy/SuccessStoryNotes";
import SuccessStoryTakeAways from "Modules/SuccessStory/PreviewSuccessStory/TakeAwaysCopy/SuccessStoryTakeAways";
// import { CheckCircleOutline } from "@material-ui/icons";
import ClosedDateLockSS from "../ClosedDateLockSS";
const TeamSuccessStories = ({
  reportType,
  state,
  saveDiscussionPoints,
  loading,
  saveDiscussionLoader,
  _loggedInUserDetails,
  companyDetail,
  saveAcknowledgementLoader,
  saveAcknowledgementDetails,
  // teamAcknowledgementDetailsLoading,
  targetAction,
  discussionPointsLoading,
}) => {
  const classes = useStyles();
  const selectedSuccessStory = useRecoilValue(selectedSuccessStoryState);
  const { loadingTargets, loadingCreatorDetails, loadingLinkedTargets } =
    loading;
  const { profile } = companyDetail;
  const { getLinkedTargets } = useTeamSuccessStoryApis();

  return (
    <Box className={classes.root}>
      <ClosedDateLockSS selectedSuccess={selectedSuccessStory} />
      <Box mt={2} className={classes.bannerSection} position="relative">
        <UserSummaryBanner
          userRedirection={false}
          userDetails={get(state, "creatorDetails")}
          companyLogo={profile}
          loader={loadingCreatorDetails}
        />
        {selectedSuccessStory?.status === "Closed" ? (
          <span className={classes.completedTag}>Completed</span>
        ) : selectedSuccessStory?.status === "Archived" ? (
          <span className={classes.archivedTag}>Archived</span>
        ) : (
          <span className={classes.ssTag}>Team success story</span>
        )}

        {/* <span className={classes.completedTag}>Completed</span> */}
      </Box>
      <Card className={classes.kpiSection}>
        <SuperviseeKpiList
          kpis={{
            totalKpis: get(state, "kpis.totalKpis", {}),
            userWiseKPIs: get(state, "kpis.userWiseKPIs", []),
          }}
          id={get(selectedSuccessStory, "id", "")}
          reportType={reportType}
          kpiLabel={selectedKpiLabel(
            get(selectedSuccessStory, "kpiSelectionOption", "")
          )}
          kpiSelectionOption={get(
            selectedSuccessStory,
            "kpiSelectionOption",
            ""
          )}
          loading={loading}
          customStartDate={get(selectedSuccessStory, "customStartDate", "")}
          customEndDate={get(selectedSuccessStory, "customEndDate", "")}
          performanceCycle={get(selectedSuccessStory, "performanceCycle", "")}
        />
      </Card>
      <SuccessstoryNotes
        state={state}
        targetAction={targetAction}
        saveDiscussionPoints={saveDiscussionPoints}
        saveDiscussionLoader={saveDiscussionLoader}
        loader={discussionPointsLoading}
      />
      <TargetDetails
        showTeamTargets={true}
        targets={get(state, "targets")}
        loader={loadingTargets}
        type={true}
      />
      <WeightedLinkedTargets
        linkedTargetsLoading={loadingLinkedTargets}
        users={orderBy(
          uniqBy(
            get(state, "kpis.userWiseKPIs", []).map((res) => res.supervisee),
            "userid"
          ),
          "firstName"
        )}
        isTeamSuccessStory={true}
        selectedSuccessStory={selectedSuccessStory}
        getSelectedUserDetails={(user) => {
          getLinkedTargets({
            variables: {
              viewType: "Report",
              successStoryWidgets: "LinkedTargets",
              successStoryId: get(selectedSuccessStory, "id", ""),
              successStoryType: get(selectedSuccessStory, "type", ""),
              userId: get(user, "userid", ""),
            },
          });
        }}
      />
      {!isEmpty(get(state, DISCUSSIONPOINT_MANAGER, null)) ? (
        <SuccessStoryTakeAways
          saveAcknowledgementDetails={saveAcknowledgementDetails}
          acknowledgementDetails={get(state, "acknowledgementDetails")}
          saveAcknowledgementLoader={saveAcknowledgementLoader}
          loggedInUserDetails={_loggedInUserDetails}
          state={state}
          selectedSuccessStory={selectedSuccessStory}
        />
      ) : (
        ""
      )}
    </Box>
  );
};
export default TeamSuccessStories;
